import { Typography, Grid, TextField } from "@mui/material";
import { CardCvcElement, CardExpiryElement, CardNumberElement } from "@stripe/react-stripe-js";
import { StripeElementType } from "@stripe/stripe-js";
import { useFormContext } from "react-hook-form";
import AppTextInput from "../../app/components/AppTextInput";
import { StripeInput } from "./StripeInput";
import agent from "../../app/api/agent";
import { useEffect } from "react";


interface Props {
    cardState: {elementError: {[key in StripeElementType]?: string}}
    onCardInputChange: (event: any) => void
    isRural: boolean | undefined
    isInternational: boolean
    shippingOption: string
}
export default function PaymentForm({cardState, onCardInputChange, isRural, isInternational, shippingOption}: Props) {


  const {control} = useFormContext()

  // send to backend and make the payment service calculate delivery fee and total fee (to update the amount on Stripe)
  useEffect(() => {
    if (isInternational === true) {
      agent.Payments.createPaymentIntent(false, true, '')
      .catch(error => console.log(error))
    }
    if (isRural === true && isInternational === false) {
      agent.Payments.createPaymentIntent(true, false, shippingOption)
      .catch(error => console.log(error))
    } else if (isRural === false && isInternational === false) {
      agent.Payments.createPaymentIntent(false, false, shippingOption)
      .catch(error => console.log(error))
    } 

    }, [isRural, isInternational, shippingOption])

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Payment method
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <AppTextInput
            name="nameOnCard"
            label="Name on card"  
            control={control}
            
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            onChange={onCardInputChange}
            error={!!cardState.elementError.cardNumber}
            helperText={cardState.elementError.cardNumber}
            id="cardNumber"
            label="Card number"
            fullWidth
            autoComplete="cc-number"
            variant="outlined"
            InputLabelProps={{shrink: true}} // label shinks when somebody typing
            InputProps={{
                inputComponent: StripeInput,
                inputProps: {
                    component: CardNumberElement
                }
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            onChange={onCardInputChange}
            error={!!cardState.elementError.cardExpiry}
            helperText={cardState.elementError.cardExpiry}
            id="expDate"
            label="Expiry date"
            fullWidth
            autoComplete="cc-exp"
            variant="outlined"
            InputLabelProps={{shrink: true}} 
            InputProps={{
                inputComponent: StripeInput,
                inputProps: {
                    component: CardExpiryElement
                }
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            onChange={onCardInputChange}
            error={!!cardState.elementError.cardCvc}
            helperText={cardState.elementError.cardCvc}
            id="cvv"
            label="CVV"
            fullWidth
            autoComplete="cc-csc"
            variant="outlined"
            InputLabelProps={{shrink: true}} 
            InputProps={{
                inputComponent: StripeInput,
                inputProps: {
                    component: CardCvcElement
                }
            }}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <FormControlLabel
            control={<Checkbox color="secondary" name="saveCard" value="yes" />}
            label="Remember credit card details for next time"
          />
        </Grid> */}
      </Grid>
    </>
  );
}